var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNoBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.43 6.713h-2.353v8.629c0 .867-.702 1.569-1.568 1.569H11.98l-3.586 3.137h7.157l5.286 3.776a.784.784 0 0 0 1.24-.638v-3.138h2.354a.785.785 0 0 0 .784-.784V7.497a.785.785 0 0 0-.784-.784z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.724.438H.898a.784.784 0 0 0-.785.784v13.335c0 .434.35.785.785.785h3.137v4.706a.785.785 0 1 0 1.3.59l6.055-5.296h8.334c.434 0 .785-.35.785-.785V1.222a.784.784 0 0 0-.785-.784z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBg);
export default __webpack_public_path__ + "static/media/logo-no-bg.7789b4581249e3cd2d7706565a078533.svg";
export { ForwardRef as ReactComponent };